import './about.css'
import Abouot from './components/aboutSidebar/AbSidebar'

const About = () => {
    return (
        <div className="about">
            <Abouot />
        </div>
    )
}

export default About
